module.exports = function() {
  return new Worker(__webpack_public_path__ + "e2be3fb6d58bbed9f607.worker.js");
};